import { render, staticRenderFns } from "./SidebarTelemeteri.vue?vue&type=template&id=1a330cf8&"
import script from "./SidebarTelemeteri.vue?vue&type=script&lang=js&"
export * from "./SidebarTelemeteri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports